/**
 * Категорії каталогу.
 *
 * Бекенд уже вміє фільтрувати за назвою (products/filtered?search=), тому
 * категорія за типом одягу не потребує змін API: слово з назви моделі
 * і є фільтром. Перевірено на живому каталозі — разом дає всі 26 моделей.
 */
export interface CollectionInfo {
  id: string;
  slug: string;
  label: string;
}

export const COLLECTIONS: CollectionInfo[] = [
  {
    id: "f7744a9d-f8a5-4b82-b00f-274139cd737b",
    slug: "au26",
    label: "ОСІНЬ AU26",
  },
  {
    id: "5c4d326e-3586-4dfb-9f1b-cbc5ba772e45",
    slug: "su26",
    label: "ЛІТО SU26",
  },
];

export const AU26 = COLLECTIONS[0];
export const SU26 = COLLECTIONS[1];

export interface CategoryInfo {
  slug: string;
  label: string;
  /** підставляється в products/filtered?search= */
  search: string;
}

export const CATEGORIES: CategoryInfo[] = [
  { slug: "kurtky", label: "Куртки", search: "Куртка" },
  { slug: "svitshoty", label: "Світшоти", search: "Світшот" },
  { slug: "khudi", label: "Худі", search: "Худі" },
  { slug: "shtany", label: "Штани", search: "Штани" },
  { slug: "shorty", label: "Шорти", search: "Шорти" },
  { slug: "futbolky", label: "Футболки", search: "Футболка" },
  { slug: "sukni", label: "Сукні", search: "Сукня" },
  { slug: "kostiumy", label: "Костюми", search: "костюм" },
];
